<template>
    <div class="payments-method border-bottom pb-3">
        <div class="payments-method-options">
            <div v-for="(option, index) in options" :key="index">
                <input :id="option.value" name="payment_provider" type="radio" :value="option.value" v-model="selectedOption" @change="handlePaymentMethod">
                <label :for="option.value">
                    <img :src="option.image" :alt="option.text">
                </label>
            </div>
        </div>
        <label class="d-block m-0 pt-2">
            {{ $t('taxi.pages.summary.payment_ecard') }}
        </label>
        <small> {{ $t('taxi.pages.summary.payment_ecard_optional_info') }}</small>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                selectedOption: 'ecard',
                options: [
                    // { value: 'p24', image: '/images/przelewy24.svg' },
                    { value: 'ecard', image: '/images/ecard.svg' },
                ],
            };
        },
        created() {
            // set value on first render
            this.$emit('payment-method-change', this.selectedOption);
        },
        methods: {
            handlePaymentMethod(e) {
                this.$emit('payment-method-change', e.target.value);
            },
        },
    };
</script>

<style scoped>
    .payments-method-options {
        display: flex;
        align-items: center;
        gap: 10px;
        padding-top: 10px;
    }

    input[type="radio"] {
        display: none;
    }

    input[type="radio"] + label {
        border: 1px solid #ddd;
        display: inline-flex;
        padding: 10px;
        cursor: pointer;
        width: 100px;
        height: 64px;
        align-items: center;
        justify-content: center;
    }

    input[type="radio"] + label img {
        display: block;
        object-fit: contain;
        height: 100%;
        width: 100%;
    }

    input[type="radio"]:checked + label {
        border-color: #ba1913;
    }

    small {
        display: block;
        font-size: 10px;
    }
</style>
